module.exports = __webpack_public_path__ + "static/media/jquery_ajax2.954678da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/skills/jquery_ajax2.png
// module id = 66
// module chunks = 0